import { useState } from 'react'

export interface Dialog {
  open: boolean
  openDialog: () => void
  closeDialog: () => void
  handleOpen: () => void
  handleClose: () => void
}

export default function useDialog(): Dialog {
  /**
   * Indicates if the dialog is open.
   */
  const [open, setOpen] = useState(false)

  /**
   * Open the dialog.
   */
  function openDialog(): void {
    setOpen(true)
  }

  /**
   * Close the dialog.
   */
  function closeDialog(): void {
    setOpen(false)
  }

  return {
    open,
    openDialog,
    closeDialog,
    handleOpen: openDialog,
    handleClose: closeDialog
  }
}
